// src/pages/Tutorial.js
import React from 'react';
import styled from 'styled-components';

const TutorialPage = styled.div`
  padding-top: 80px;
  min-height: 100vh;
  background: ${props => props.theme.colors.background};
`;

const Tutorial = () => {
  return (
    <TutorialPage>
      <h1>Tutorial</h1>
      {/* Add tutorial content */}
    </TutorialPage>
  );
};

export default Tutorial;